module.exports = require("original-require");


//////////////////
// WEBPACK FOOTER
// external "original-require"
// module id = 247
// module chunks = 0 1 3